import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import './tags.css'

function Tags({loading}) {
    const [cats, setCats] = useState([]);

    const api_uri = "https://mentorxfa.herokuapp.com/api/categories";   
 
    useEffect(() => {
        const fetchCats = async() => {
            const res = await axios.get(api_uri);
            setCats(res.data);     
        }
        fetchCats()   
    }, []);
    return (
        <ul className="tags">
            {
                loading ? <> 
            <div className="tag-item-link"> 
                <li className="tag-item">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</li>
            </div>
            <div className="tag-item-link"> 
                <li className="tag-item">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</li>
            </div>
            <div className="tag-item-link"> 
                <li className="tag-item">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</li>
            </div>
            <div className="tag-item-link"> 
                <li className="tag-item">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</li>
            </div>
          </>
             : 
                cats.map(cat =>(
                    <Link key={cat._id} to={`/?cat=${cat.name}`} className="tag-item-link">
                                <li className="tag-item">{cat.name}</li>
                    </Link>                    
                ))
            }
           
        </ul>
    )
}

export default Tags
